export enum WaveType {
  OCEAN = 1,
  SLOPE = 2,
  INCLINE = 3,
  HILLS = 4,
  FLAT = 5,
  VALLEY = 6,
}
